export default {
    validation: {
        email: 'This field must be a valid email',
        required: '{field} field is required',
        max: 'This field must have no more than {length} characters',
        min: 'This field may not be at least {length} characters',
        phoneNumber: 'Please enter a valid phone number',
        onlyLetters: 'It should contain only letters'
    }
}